import React from "react";
import { Box } from "@mui/material";

const WorkspacePage = ({ children, sx = {} }) => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "calc(100vh - 96px)",
        minWidth: 0,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        bgcolor: "#fff",
        overflow: "hidden",
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default WorkspacePage;
